import validate from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45authenticated_45global from "/var/www/pricing.bigam-dev.ru/data/www/client/middleware/01.authenticated.global.ts";
import _02_45task_45global from "/var/www/pricing.bigam-dev.ru/data/www/client/middleware/02.task.global.ts";
import page_45title_45middleware_45global from "/var/www/pricing.bigam-dev.ru/data/www/client/middleware/pageTitleMiddleware.global.ts";
import manifest_45route_45rule from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45authenticated_45global,
  _02_45task_45global,
  page_45title_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "catalog-middleware": () => import("/var/www/pricing.bigam-dev.ru/data/www/client/middleware/catalogMiddleware.ts"),
  "concurrent-middleware": () => import("/var/www/pricing.bigam-dev.ru/data/www/client/middleware/concurrentMiddleware.ts"),
  "group-types-middleware": () => import("/var/www/pricing.bigam-dev.ru/data/www/client/middleware/groupTypesMiddleware.ts"),
  "value-parameters-middleware": () => import("/var/www/pricing.bigam-dev.ru/data/www/client/middleware/valueParametersMiddleware.ts")
}